import Api from "./Api";

export default {
  syncRateCards: function() {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards/sync`;
      Api.put(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRateCards() {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getRateCardDetails(ratecardid, ratecardsetversionid) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards/${ratecardid}/${ratecardsetversionid}/ratesdata`;
      Api.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addRateCardMapping(id, mapping) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards/${id}/mapping`;
      Api.post(url, mapping)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  removeMapping(rateCardId, mappingId) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards/${rateCardId}/mapping/${mappingId}`;
      Api.delete(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateRateCardTaskMapping(rateCard) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}ratecards/${rateCard.id}/taskmappings`;
      Api.put(url, rateCard)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
